import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';
import history from './../history'


export const INITIAL_STATE = Immutable({
    partnersList: {
        loaded: false,
        isLoading: false,
        data: []
    },
    countryList: {
        loaded: false,
        isLoading: false,
        data: []
    },
    stateList: {
        loaded: false,
        isLoading: false,
        countryId: 0,
        data: []
    },
    cityList: {
        loaded: false,
        isLoading: false,
        stateId: 0,
        data: []
    },
    specialityList: {
        loaded: false,
        isLoading: false,
        data: []
    },
    offersList: {
        loaded: false,
        isLoading: false,
        data: []
    },

    vaccineList: {
        loaded: false,
        isLoading: false,
        data: []
    },
    glossary: [],

    currentAppLocation: '/',

    s3Access: {

    }
});



const fetchingPartnersList = (state, action) => {
    return state.merge({
        partnersList: {
            isLoading: true
        }
    })
};

const responsePartnersList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            partnersList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            partnersList: {
                isLoading: false
            }
        })
    }
};


const fetchingCountryList = (state, action) => {
    return state.merge({
        countryList: {
            isLoading: true
        }
    })
};

const responseCountryList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            countryList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            countryList: {
                isLoading: false
            }
        })
    }
};


const fetchingStateList = (state, action) => {
    return state.merge({
        stateList: {
            loaded: false,
            isLoading: true,
            countryId: action.countryId
        }
    })
};

const responseStateList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            stateList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            stateList: {
                loaded: false,
                isLoading: false,
                data: []
            }
        })
    }
};


const fetchingCityList = (state, action) => {
    return state.merge({
        cityList: {
            loaded: false,
            isLoading: true,
            stateId: action.stateId
        }
    })
};

const responseCityList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            cityList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            cityList: {
                loaded: false,
                isLoading: false,
                data: []
            }
        })
    }
};


const fetchingSpecialityList = (state, action) => {
    return state.merge({
        specialityList: {
            isLoading: true
        }
    })
};

const responseSpecialityList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            specialityList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            specialityList: {
                isLoading: false
            }
        })
    }
};


const fetchingOffersList = (state, action) => {
    return state.merge({
        offersList: {
            isLoading: true
        }
    })
};

const responseOffersList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            offersList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            offersList: {
                isLoading: false
            }
        })
    }
};


const fetchingVaccination = (state, action) => {
    return state.merge({
        vaccineList: {
            isLoading: true
        }
    })
};

const responseVaccineList = (state, action) => {
    if(Boolean(action.response.ok)) {
        return state.merge({
            vaccineList: {
                loaded: true,
                isLoading: false,
                data: action.response.data
            }
        })
    }

    else {
        return state.merge({
            vaccineList: {
                isLoading: false
            }
        })
    }
};

const formatGlossaryItem = (glossaryItem) =>  JSON.parse(glossaryItem.json_value).data

const sortGlossaryItems = (glossaryItem, nextGlossaryItem) => glossaryItem.contentFirstLetter > nextGlossaryItem.contentFirstLetter ? 1 : -1

const storeGlossary = (state, action) => state.merge({glossary: Boolean(action.error) ? [] : action.payload.map(formatGlossaryItem).sort(sortGlossaryItems) })

const changeCurrentLocation = (state, action) => {

    history.push(action.location)
    return state.merge({
        currentAppLocation: action.location
    })
}

const responseS3Access = (state, action) => {
    return state.merge({
        s3Access: action.response
    })
}

const ACTION_HANDLERS = {
    [Types.FETCH_PARTNERS]: fetchingPartnersList,
    [Types.RESPONSE_PARTNERS]: responsePartnersList,
    [Types.FETCH_COUNTRIES]: fetchingCountryList,
    [Types.RESPONSE_COUNTRIES]: responseCountryList,
    [Types.FETCH_STATES]: fetchingStateList,
    [Types.RESPONSE_STATES]: responseStateList,
    [Types.FETCH_CITIES]: fetchingCityList,
    [Types.RESPONSE_CITIES]: responseCityList,
    [Types.FETCH_SPECIALITIES]: fetchingSpecialityList,
    [Types.RESPONSE_SPECIALITIES]: responseSpecialityList,
    [Types.FETCH_OFFERS]: fetchingOffersList,
    [Types.RESPONSE_OFFERS]: responseOffersList,
    [Types.FETCH_VACCINATION]: fetchingVaccination,
    [Types.RESPONSE_VACCINATION]: responseVaccineList,
    [Types.STORE_GLOSSARY]: storeGlossary,
    [Types.CHANGE_CURRENT_LOCATION]: changeCurrentLocation,
    [Types.RESPONSE_S3_ACCESS]: responseS3Access
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)